/**
 * Created on 2021/6/1.
 */
define('controllers/myaccount/balance/account-flow-transfer.ctrl',['app', 'mainCons'], function (app,mainCons) {
    app.controller('FlowTransferCtrl', ['$scope','OpenTrade', '$stateParams','$rootScope','auiUpload','commonUtils','$state','OpenOther','auiDialog','UserInfo','UserInfoPreload', function ($scope, OpenTrade, $stateParams,$rootScope, auiUpload, commonUtils, $state, OpenOther, auiDialog,UserInfo,UserInfoPreload ) {
        $scope.orderId = $stateParams.orderId
        var Model = $scope.Model = {};
        Model.accountEmail = '';
        Model.flowParams = {};
        Model.accountPhone = '';
        Model.transferReasonCode = 1; // 申请转移原因码 1失效 2其他
        Model.transferReason= ''; // 申请原因
        Model.flowParams.orderId = $scope.orderId; // 申请转移id
        Model.accountType = 0; // 账户类型 0开发者  1代理
        Model.account = ''; // 推广帐号
        Model.accountName = ''; // 推广帐号企业名称
        Model.appealAttach = ''; // 申请附件
        Model.transferHelp = window.sysUrlCfg.documentHref.appPromote; // 服务地址
        Model.downChangeNameTemplate = systemParaConf.fileDownLoadUrl; // 下载的模板
        Model.fileUrl = ''
        Model.fileName = ''
        Model.errorStatus= [
            {
                errorCode: 90102169,
                errorMes: '您输入转入推广帐号不存在，请确认后重新输入转入推广帐号'
            },{
                errorCode: 90102173,
                errorMes: '您的单日申请次数已超过5次'
            },
            {
                errorCode: 90102172,
                errorMes: '您转入的帐号为暂不支持转入的海外/个人/未实名账户，请确认后重新提交'
            },
            {
                errorCode: 90102171,
                errorMes: '您输入的转入推广账号与转入的推广账号所属企业名称不匹配，请重新确认输入内容'
            },
            {
                errorCode: 90102170,
                errorMes: '您的帐号为暂不支持转入的海外/个人/未实名账户，请确认后重新提交'
            },
            {
                errorCode: 90102175,
                errorMes: '您当前的帐号状态异常，请确认后重新提交'
            },
            {
                errorCode: 90102176,
                errorMes: '您当前转入的帐号状态异常，请确认后重新提交'
            },
            {
                errorCode: 88820262,
                errorMes: '转入帐号与被转移主帐号不能相同，请重新输入转入帐号'
            },
            {
                errorCode: 90102177,
                errorMes: '转入帐号与被转移主帐号不能相同，请重新输入转入帐号'
            }

        ] /// 异常状态码
        //调用接口获取订单详情
        OpenTrade.getOrderDetail({
            req: {
                orderId: $scope.orderId
            }
        }).then(function (res) {
            if (res) {
                Model.money = res.orderInfo.money
            }
        })

        $scope.getPicture = getPicture

        $scope.doSubmit = doSubmit

        $scope.cancel = cancel

        function init() {
            commonUtils.picExtend("imges1");
        }

        init()

        // 上传图片
        Model.uploadAppealAttach = function (files,options) {
            auiUpload.uploadOpenTrade(files, '1', options).then(function (fileUrl) {
                if(files && files.length > 0) {
                    Model.fileName = files[0].name
                }
                Model.fileUrl = fileUrl;
                Model.appealAttach = fileUrl;
            });

        };

        // 图片预览
        function getPicture() {
            document.getElementById('myPicture').click()
        }

        //删除图片或者附件
        $scope.delimg = function (item) {
            Model.appealAttach = ''
        };

        // 提交表单
        function doSubmit(isValid) {
            UserInfo.userAcctInfoList().then(function (data){
                Model.accountEmail = data.accountEmail;
                Model.accountPhone = data.accountPhone
                if(Model.accountEmail && Model.accountEmail === Model.account) {
                    auiDialog.fail('转入帐号与被转移主帐号不能相同，请重新输入转入帐号');
                    return
                }
                if(Model.accountPhone && Model.accountPhone === Model.account) {
                    auiDialog.fail('转入帐号与被转移主帐号不能相同，请重新输入转入帐号');
                    return
                }
                if(isValid) {
                    var submitParams = {
                        serviceName: 'HuaweiDeveloper',
                        orderID: $scope.orderId,
                        transferUserRole: Model.accountType,
                        invalidRsn: Model.transferReasonCode === 1 ? '失效后申请转移' : Model.transferReason,
                        transferAccount: Model.account,
                        transferCompanyName: Model.accountName,
                    }
                    if(Model.accountType === 1) {
                        submitParams.applyInvalidappendixUrl = Model.appealAttach
                    }
                    OpenOther.invalidOrder({
                        req: submitParams
                    }).then(function (res) {
                        auiDialog.success('提交成功',function () {
                            $state.go('MyAccount.mainbalance.bill', {signParty: 2})
                        });
                    }).catch(function (err) {
                        var msg = ''
                        for(var i = 0; i < Model.errorStatus.length; i++) {
                            if(Model.errorStatus[i].errorCode === err.NSP_STATUS) {
                                msg = Model.errorStatus[i].errorMes
                                break
                            }else {
                                msg = '操作失败，请将问题发送到shiningstar@huawei.com，将有工作人员联系您解决'
                            }
                        }
                        auiDialog.fail(msg);
                    })
                }else {
                    if(Model.transferReasonCode === 2 && Model.transferReason === '') {
                        $scope.flowTransfer.transferReason.$setDirty();
                    }
                    if(Model.account === '' || Model.account === undefined) {
                        $scope.flowTransfer.account.$setDirty();
                    }
                    if(Model.accountName === '' || Model.accountName === undefined) {
                        $scope.flowTransfer.accountName.$setDirty();
                    }
                    if(Model.accountType === 1) {
                        if(Model.appealAttach === '' || Model.appealAttach=== undefined){
                            $scope.flowTransfer.appealAttach.$setDirty();
                        }
                    }
                }
            })
        }
        // 取消按钮
        function cancel() {
            $state.go('MyAccount.mainbalance.bill', {signParty: 2})
        }

    }])
})
;
